  (function() {
    'use strict';
    
    // --- CONTROLLER CLASS ---
    class PlayerManager {
      constructor(sectionId, data, config) {
        this.id = sectionId;
        this.data = data;
        this.config = config;
        
        this.state = {
          filtered: [],
          filter: { search: '', team: '' },
          sort: 'default',
          view: 'grid',
          page: 1
        };
        
        this.els = {
          grid: document.getElementById(`sbp-grid-${this.id}`),
          input: document.getElementById(`sbp-search-${this.id}`),
          teamSelect: document.getElementById(`sbp-filter-team-${this.id}`),
          sortSelect: document.getElementById(`sbp-sort-${this.id}`),
          count: document.getElementById(`sbp-count-${this.id}`),
          loadBtn: document.getElementById(`sbp-load-btn-${this.id}`),
          empty: document.getElementById(`sbp-empty-${this.id}`),
          resetBtn: document.getElementById(`sbp-reset-btn-${this.id}`),
          toggles: document.querySelectorAll(`#sbp-toolbar-${this.id} .sbp-switch-btn`)
        };
        if (this.els.grid) {
          this.init();
        }
      }
      init() {
        // Populate Team Dropdown
        // Clear previous options to prevent duplicates
        while (this.els.teamSelect.options.length > 1) {
          this.els.teamSelect.remove(1);
        }
        const teams = [...new Set(this.data.map(p => p.team).filter(t => t && t.trim() !== ''))].sort();
        teams.forEach(t => {
          const opt = document.createElement('option');
          opt.value = t;
          opt.textContent = t;
          this.els.teamSelect.appendChild(opt);
        });
        // Event Listeners
        this.els.input.addEventListener('input', this.debounce((e) => {
          this.state.filter.search = e.target.value.toLowerCase().trim();
          this.applyFilters();
        }, 300));
        this.els.teamSelect.addEventListener('change', (e) => {
          this.state.filter.team = e.target.value;
          this.applyFilters();
        });
        this.els.sortSelect.addEventListener('change', (e) => {
          this.state.sort = e.target.value;
          this.applyFilters();
        });
        this.els.toggles.forEach(btn => {
          btn.addEventListener('click', () => {
             this.switchView(btn.dataset.view);
          });
        });
        if(this.els.loadBtn) {
          this.els.loadBtn.addEventListener('click', () => {
            this.state.page++;
            this.render();
          });
        }
        if (this.els.resetBtn) {
          this.els.resetBtn.addEventListener('click', () => {
            this.state.filter.search = '';
            this.state.filter.team = '';
            this.els.input.value = '';
            this.els.teamSelect.value = '';
            this.applyFilters();
          });
        }
        // 3. Initial Render
        this.applyFilters();
      }
      applyFilters() {
        // Filter
        this.state.filtered = this.data.filter(p => {
          const nameMatch = p.name.toLowerCase().includes(this.state.filter.search);
          const teamMatch = !this.state.filter.team || p.team === this.state.filter.team;
          return nameMatch && teamMatch;
        });
        // Sort
        this.sortData();
        // Reset Pager
        this.state.page = 1;
        this.render();
      }
      sortData() {
        const mode = this.state.sort;
        const sorted = [...this.state.filtered];
        if (mode === 'name_asc') sorted.sort((a,b) => a.name.localeCompare(b.name));
        else if (mode === 'name_desc') sorted.sort((a,b) => b.name.localeCompare(a.name));
        else if (mode === 'team_asc') sorted.sort((a,b) => (a.team||'').localeCompare(b.team||''));
        
        // 'default' keeps original order
        this.state.filtered = sorted;
      }
      switchView(mode) {
        this.state.view = mode;
        
        // Update Buttons
        this.els.toggles.forEach(btn => {
          btn.classList.toggle('active', btn.dataset.view === mode);
        });
        // Update Grid Class
        this.els.grid.className = `sbp-grid view-mode-${mode}`;
        
        this.render();
      }
      render() {
        const { filtered, page, view } = this.state;
        const total = filtered.length;
        const showing = Math.min(page * this.config.perPage, total);
        const toRender = filtered.slice(0, showing);
        // Update Count
        this.els.count.textContent = `מציג ${showing} מתוך ${total} שחקנים`;
        // Empty State
        if (total === 0) {
          this.els.grid.style.display = 'none';
          this.els.empty.style.display = 'block';
          this.els.empty.hidden = false;
          if (this.els.loadBtn) this.els.loadBtn.style.display = 'none';
          return;
        }
        this.els.grid.style.display = 'grid';
        this.els.empty.style.display = 'none';
        this.els.empty.hidden = true;
        // Build HTML
        this.els.grid.innerHTML = toRender.map((p, index) => {
          const delay = (index % this.config.perPage) * 0.05;
          const badgeHtml = (p.showBadge && p.badge) ? `<span class="sbp-badge">${p.badge}</span>` : '';
          const imgHtml = p.image 
            ? `<img src="${p.image}" alt="${p.name}" class="sbp-img" loading="lazy">` 
            : `<div style="width:100%;height:100%;background:#f0f0f0;"></div>`;
          return `
            <article class="sbp-card sbp-card-anim" style="animation-delay: ${delay}s">
              <a href="${p.link}" class="sbp-card-inner">
                <div class="sbp-img-wrap">
                  ${badgeHtml}
                  ${imgHtml}
                </div>
                <div class="sbp-info">
                  <h3 class="sbp-name">${p.name}</h3>
                  ${p.team ? `<p class="sbp-team">${p.team}</p>` : ''}
                </div>
              </a>
            </article>
          `;
        }).join('');
        // Pagination Button
        if (this.els.loadBtn) {
          this.els.loadBtn.style.display = showing < total ? 'inline-block' : 'none';
        }
        // Re-init Tilt (Desktop Only)
        if (window.matchMedia('(min-width: 1024px)').matches && view === 'grid') {
          this.init3DTilt();
        }
      }
      init3DTilt() {
        const cards = this.els.grid.querySelectorAll('.sbp-card');
        cards.forEach(card => {
          card.onmousemove = (e) => {
            const inner = card.querySelector('.sbp-card-inner');
            const rect = card.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;
            
            // Calc rotation
            const rotateX = ((y / rect.height) - 0.5) * -8; // Max 8deg
            const rotateY = ((x / rect.width) - 0.5) * 8;
            inner.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(1.02)`;
          };
          
          card.onmouseleave = () => {
             const inner = card.querySelector('.sbp-card-inner');
             inner.style.transform = `perspective(1000px) rotateX(0) rotateY(0) scale(1)`;
          };
        });
      }
      debounce(fn, ms) {
        let timer;
        return (...args) => {
          clearTimeout(timer);
          timer = setTimeout(() => fn.apply(this, args), ms);
        };
      }
    }

  // --- BOOTSTRAP (reads the inline JSON data-island emitted by the section) ---
  function sbpBoot() {
    document.querySelectorAll('script[type="application/json"][id^="sbp-data-"]').forEach(function (el) {
      if (el.dataset.sbpInit) return;
      el.dataset.sbpInit = '1';
      var cfg;
      try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
      new PlayerManager(cfg.sectionId, cfg.players, { perPage: cfg.perPage });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sbpBoot);
  } else {
    sbpBoot();
  }
  document.addEventListener('shopify:section:load', sbpBoot);
})();
